module.exports = __webpack_public_path__ + "browserconfig.xml";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/browserconfig.xml
// module id = 372
// module chunks = 0